import { Component, Input } from '@angular/core';

import * as _ from 'lodash';

import { FirebaseService } from '../../services/firebase.service';

import { Item } from '../../models/item';

// import dictionaries
import { Conversions } from '../../dictionaries';

@Component({
  selector    : 'select-unit',
  templateUrl : 'select-unit.html',
  styleUrls   : [ 'select-unit.scss' ]
})

export class SelectUnitComponent {
  @Input() item : Item;

  constructor(
    private firebaseService : FirebaseService
  ) {}

  // retrieve list of measurements that can be converted to/from the current unit type
  // then create a paired array to allow sorting based on the smallest measurement to the largest
  possibleConversions() : string[] {
    let pairedArray = _.toPairs(Conversions[this.item.unitType]);

    pairedArray.sort(function(a, b) {
      return b[1] - a[1];
    });

    return _.unzip(pairedArray)[0];
  }

  convertMeasurement(event) {
    const newQty = this.firebaseService.convertMeasurement(
      this.item.unit,
      event.target.value,
      this.item.qty
    );

    let changes = {
      qty  : newQty,
      unit : event.target.value
    };

    this.firebaseService.updateItem(this.item, changes);
  }
}


// WEBPACK FOOTER //
// /Users/briznad/Documents/WebDev/personal/cartmigo/cartmigo-beta/src/app/components/select-unit/select-unit.ts